import { Icon, IconProps } from '@cognite/cogs.js';

export const BaseIcon = (props: IconProps) => {
  return <Icon {...props} />;
};
